<template>
  <div class="max-w-7xl mx-auto sm:px-2 lg:px-8 pb-12">
    <div v-if="session == null">
      <submission-spinner></submission-spinner>
    </div>
    <div v-else-if="session.watchStatus === 'IDLE'">
      <preview-session-page :session="session" :show-streams="showStreams" />
    </div>
    <div v-else-if="session.watchStatus === 'COMPLETE'">
      <previous-session-page :session="session" />
    </div>
  </div>
</template>

<script>
import PreviewSessionPage from "../components/PreviewSessionPage";
import PreviousSessionPage from "../components/PreviousSessionPage";
import { sanityClient } from "../utils/sanity";
import SubmissionSpinner from "../components/SubmissionSpinner";
export default {
  name: "Session",
  components: {
    SubmissionSpinner,
    PreviewSessionPage,
    PreviousSessionPage
  },
  data() {
    return {
      session: null,
      subscription: null,
      showStreams: true
    };
  },
  created() {
    this.fetchSession();
    // this.subscription = this.subscribe();
  },
  mounted: function() {
    this.pollData();
  },
  beforeDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.polling) {
      clearInterval(this.polling);
    }
  },
  methods: {
    pollData() {
      this.polling = setInterval(() => {
        this.fetchSession();
      }, 30000);
    },
    fetchSession() {
      const slug = this.$route.params.slug;
      const queryString = ` {
        "session" : *[_type == 'session' && slug.current == $slug][0]{speakers[]->{...}, tutorials[]->{...}, productCompatibility[]->{...}, ...},
        "settings" : *[_id =='siteSettings'][0] {showStreams}
      }
      
      `;

      sanityClient
        .fetch(queryString, { slug })
        .then(res => {
          this.session = res.session;
          this.showStreams = res.settings.showStreams;
          if (this.session.watchStatus === "LIVE") {
            window.location.href = "/live";
          }
        })
        .catch(err => {
          console.error(err);
        });
    }
  }
};
</script>
